import {NavigateFunction} from "react-router-dom";

const getMenuItems = (navigate: NavigateFunction) => [
    { label: 'Users', onClick: () => navigate("/admin/users") },
    { label: 'Groups', onClick: () => navigate("/admin/groups") },
    { label: 'PostReports', onClick: () => navigate("/admin/reports") },
];

export default getMenuItems;